/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type C4CModeEnum = "CASE4CAUSE" | "GRAPEFULCLUB" | "NONE" | "%future added value";
export type CartAddInput = {
    readonly id: string;
    readonly quantity?: number | null;
    readonly cartItems?: ReadonlyArray<string | null> | null;
    readonly productApiId?: string | null;
    readonly clientMutationId?: string | null;
};
export type CartAddMutationVariables = {
    readonly input: CartAddInput;
};
export type CartAddMutationResponse = {
    readonly cartAdd: ({
        readonly cartEntryEdge: ({
            readonly node: ({
                readonly id: string;
                readonly quantity: number | null;
                readonly product: ({
                    readonly id: string;
                    readonly productId: string | null;
                }) | null;
            }) | null;
        }) | null;
        readonly cart: ({
            readonly id: string;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
            readonly c4cMode: C4CModeEnum | null;
            readonly enrollingAsPc: boolean | null;
            readonly totalSavings: number | null;
            readonly promoCodeSavings: number | null;
            readonly pcPotentialSavings: ReadonlyArray<number | null> | null;
            readonly viaQualifiedCartTotal: number | null;
            readonly totalNumberOfItems: number | null;
            readonly subTotalPriceOfItems: number | null;
            readonly subTotalPriceOfItemsWithPromoCodes: number | null;
            readonly eventId: string | null;
            readonly event: ({
                readonly id: string;
                readonly trinityPartyType: string | null;
            }) | null;
            readonly promoCodes: ReadonlyArray<({
                readonly code: string | null;
                readonly promoDescription: string | null;
                readonly thresholds: ReadonlyArray<({
                    readonly discountAmount: string | null;
                    readonly discountAmountEach: string | null;
                }) | null> | null;
            }) | null> | null;
            readonly entries: ({
                readonly edges: ReadonlyArray<({
                    readonly cursor: string;
                    readonly node: ({
                        readonly id: string;
                        readonly quantity: number | null;
                        readonly product: ({
                            readonly id: string;
                            readonly price: number | null;
                            readonly name: string | null;
                            readonly priceSale: number | null;
                            readonly productId: string | null;
                            readonly wineBottleQuantity: number | null;
                            readonly isWinePack: boolean | null;
                            readonly productPermissions: ({
                                readonly oneCommerce: ({
                                    readonly preferredCustomer: ({
                                        readonly add: boolean | null;
                                    }) | null;
                                }) | null;
                            }) | null;
                            readonly images: ({
                                readonly squareFront: string | null;
                                readonly productCatalog: string | null;
                                readonly productFront: string | null;
                                readonly productBack: string | null;
                            }) | null;
                            readonly promoCodeDiscount: ({
                                readonly case4Cause: ({
                                    readonly case6SKU: string | null;
                                    readonly case12SKU: string | null;
                                    readonly donationEligible: boolean | null;
                                    readonly case12PriceUSD: number | null;
                                    readonly case6PriceUSD: number | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null;
                }) | null> | null;
            }) | null;
            readonly entriesV2: ({
                readonly edges: ReadonlyArray<({
                    readonly cursor: string;
                    readonly node: ({
                        readonly id: string;
                        readonly quantity: number | null;
                        readonly product: ({
                            readonly name: string | null;
                            readonly id: string;
                            readonly productId: string | null;
                            readonly price: number | null;
                            readonly finalPrice: number | null;
                            readonly productPermissions: ({
                                readonly oneCommerce: ({
                                    readonly preferredCustomer: ({
                                        readonly add: boolean | null;
                                    }) | null;
                                }) | null;
                            }) | null;
                            readonly images: ({
                                readonly squareFront: string | null;
                                readonly productCatalog: string | null;
                                readonly productFront: string | null;
                                readonly productBack: string | null;
                            }) | null;
                        }) | null;
                    }) | null;
                }) | null> | null;
            }) | null;
            readonly promoCodeDiscountedItems: ReadonlyArray<({
                readonly id: string;
                readonly nonDiscountedSkus: ({
                    readonly edges: ReadonlyArray<({
                        readonly cursor: string;
                        readonly node: ({
                            readonly id: string;
                            readonly sku: string | null;
                            readonly discountAmount: number | null;
                            readonly productId: string | null;
                            readonly quantity: number | null;
                            readonly product: ({
                                readonly id: string;
                                readonly productId: string | null;
                                readonly productURLslug: string | null;
                                readonly name: string | null;
                                readonly price: number | null;
                                readonly priceSale: number | null;
                                readonly wineBottleQuantity: number | null;
                                readonly isWinePack: boolean | null;
                                readonly productPermissions: ({
                                    readonly oneCommerce: ({
                                        readonly preferredCustomer: ({
                                            readonly add: boolean | null;
                                        }) | null;
                                    }) | null;
                                }) | null;
                                readonly promoCodeDiscount: ({
                                    readonly case4Cause: ({
                                        readonly case6PriceUSD: number | null;
                                    }) | null;
                                }) | null;
                                readonly images: ({
                                    readonly productCatalog: string | null;
                                    readonly productFront: string | null;
                                    readonly productBack: string | null;
                                    readonly squareFront: string | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null> | null;
                }) | null;
                readonly discountedSkus: ({
                    readonly edges: ReadonlyArray<({
                        readonly cursor: string;
                        readonly node: ({
                            readonly id: string;
                            readonly sku: string | null;
                            readonly discountAmount: number | null;
                            readonly productId: string | null;
                            readonly quantity: number | null;
                            readonly product: ({
                                readonly id: string;
                                readonly productId: string | null;
                                readonly productURLslug: string | null;
                                readonly name: string | null;
                                readonly price: number | null;
                                readonly priceSale: number | null;
                                readonly wineBottleQuantity: number | null;
                                readonly isWinePack: boolean | null;
                                readonly productPermissions: ({
                                    readonly oneCommerce: ({
                                        readonly preferredCustomer: ({
                                            readonly add: boolean | null;
                                        }) | null;
                                    }) | null;
                                }) | null;
                                readonly promoCodeDiscount: ({
                                    readonly case4Cause: ({
                                        readonly case6PriceUSD: number | null;
                                    }) | null;
                                }) | null;
                                readonly images: ({
                                    readonly productCatalog: string | null;
                                    readonly productFront: string | null;
                                    readonly productBack: string | null;
                                    readonly squareFront: string | null;
                                }) | null;
                            }) | null;
                        }) | null;
                    }) | null> | null;
                }) | null;
            }) | null> | null;
        }) | null;
    }) | null;
};
export type CartAddMutation = {
    readonly response: CartAddMutationResponse;
    readonly variables: CartAddMutationVariables;
};



/*
mutation CartAddMutation(
  $input: CartAddInput!
) {
  cartAdd(input: $input) {
    cartEntryEdge {
      node {
        id
        quantity
        product {
          id
          productId
        }
      }
    }
    cart {
      id
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      c4cMode
      enrollingAsPc
      totalSavings
      promoCodeSavings
      pcPotentialSavings
      viaQualifiedCartTotal
      totalNumberOfItems
      subTotalPriceOfItems
      subTotalPriceOfItemsWithPromoCodes
      eventId
      event {
        id
        trinityPartyType
      }
      promoCodes {
        code
        promoDescription
        thresholds {
          discountAmount
          discountAmountEach
        }
        id
      }
      entries(first: 1000) {
        edges {
          cursor
          node {
            id
            quantity
            product {
              id
              price
              name
              priceSale
              productId
              wineBottleQuantity
              isWinePack
              productPermissions {
                oneCommerce {
                  preferredCustomer {
                    add
                  }
                }
              }
              images {
                squareFront
                productCatalog
                productFront
                productBack
                id
              }
              promoCodeDiscount {
                case4Cause {
                  case6SKU
                  case12SKU
                  donationEligible
                  case12PriceUSD
                  case6PriceUSD
                }
              }
            }
          }
        }
      }
      entriesV2(first: 1000) {
        edges {
          cursor
          node {
            id
            quantity
            product {
              name
              id
              productId
              price
              finalPrice
              productPermissions {
                oneCommerce {
                  preferredCustomer {
                    add
                  }
                }
              }
              images {
                squareFront
                productCatalog
                productFront
                productBack
                id
              }
            }
          }
        }
      }
      promoCodeDiscountedItems {
        id
        nonDiscountedSkus {
          edges {
            cursor
            node {
              id
              sku
              discountAmount
              productId
              quantity
              product {
                id
                productId
                productURLslug
                name
                price
                priceSale
                wineBottleQuantity
                isWinePack
                productPermissions {
                  oneCommerce {
                    preferredCustomer {
                      add
                    }
                  }
                }
                promoCodeDiscount {
                  case4Cause {
                    case6PriceUSD
                  }
                }
                images {
                  productCatalog
                  productFront
                  productBack
                  squareFront
                  id
                }
              }
            }
          }
        }
        discountedSkus {
          edges {
            cursor
            node {
              id
              sku
              discountAmount
              productId
              quantity
              product {
                id
                productId
                productURLslug
                name
                price
                priceSale
                wineBottleQuantity
                isWinePack
                productPermissions {
                  oneCommerce {
                    preferredCustomer {
                      add
                    }
                  }
                }
                promoCodeDiscount {
                  case4Cause {
                    case6PriceUSD
                  }
                }
                images {
                  productCatalog
                  productFront
                  productBack
                  squareFront
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartAddInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CartAddInput!"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "quantity",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "cartEntryEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "CartEntryEdge",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "CartEntry",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    (v3 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "product",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Product",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            (v4 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "viaQualifiedCartTotal",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalUnit",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalCount",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "c4cMode",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrollingAsPc",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalSavings",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeSavings",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "pcPotentialSavings",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipEnabled",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfItems",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItems",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItemsWithPromoCodes",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "trinityPartyType",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoDescription",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "discountAmount",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "thresholds",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeThresholds",
        "plural": true,
        "selections": [
            (v22 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountAmountEach",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v24 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 1000,
            "type": "Int"
        } as any)
    ], v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "wineBottleQuantity",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isWinePack",
        "args": null,
        "storageKey": null
    } as any), v31 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "productPermissions",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductPermissions",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "AppProductPermissionsAccess",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductPermissionsAccess",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "add",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "squareFront",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productCatalog",
        "args": null,
        "storageKey": null
    } as any), v34 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productFront",
        "args": null,
        "storageKey": null
    } as any), v35 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productBack",
        "args": null,
        "storageKey": null
    } as any), v36 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "images",
        "storageKey": null,
        "args": null,
        "concreteType": "Images",
        "plural": false,
        "selections": [
            (v32 /*: any*/),
            (v33 /*: any*/),
            (v34 /*: any*/),
            (v35 /*: any*/)
        ]
    } as any), v37 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "case6PriceUSD",
        "args": null,
        "storageKey": null
    } as any), v38 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodeDiscount",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeDiscount",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "case4Cause",
                "storageKey": null,
                "args": null,
                "concreteType": "Case4Cause",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "donationEligible",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12PriceUSD",
                        "args": null,
                        "storageKey": null
                    },
                    (v37 /*: any*/)
                ]
            }
        ]
    } as any), v39 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "finalPrice",
        "args": null,
        "storageKey": null
    } as any), v40 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "sku",
        "args": null,
        "storageKey": null
    } as any), v41 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productURLslug",
        "args": null,
        "storageKey": null
    } as any), v42 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodeDiscount",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeDiscount",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "case4Cause",
                "storageKey": null,
                "args": null,
                "concreteType": "Case4Cause",
                "plural": false,
                "selections": [
                    (v37 /*: any*/)
                ]
            }
        ]
    } as any), v43 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PromoCodeItemDiscountEdge",
            "plural": true,
            "selections": [
                (v25 /*: any*/),
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PromoCodeItemDiscountTuple",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v40 /*: any*/),
                        (v22 /*: any*/),
                        (v4 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                                (v28 /*: any*/),
                                (v2 /*: any*/),
                                (v41 /*: any*/),
                                (v27 /*: any*/),
                                (v26 /*: any*/),
                                (v4 /*: any*/),
                                (v29 /*: any*/),
                                (v30 /*: any*/),
                                (v31 /*: any*/),
                                (v42 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "images",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Images",
                                    "plural": false,
                                    "selections": [
                                        (v33 /*: any*/),
                                        (v34 /*: any*/),
                                        (v35 /*: any*/),
                                        (v32 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ], v44 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "images",
        "storageKey": null,
        "args": null,
        "concreteType": "Images",
        "plural": false,
        "selections": [
            (v32 /*: any*/),
            (v33 /*: any*/),
            (v34 /*: any*/),
            (v35 /*: any*/),
            (v2 /*: any*/)
        ]
    } as any), v45 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PromoCodeItemDiscountEdge",
            "plural": true,
            "selections": [
                (v25 /*: any*/),
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PromoCodeItemDiscountTuple",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v40 /*: any*/),
                        (v22 /*: any*/),
                        (v4 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                                (v28 /*: any*/),
                                (v2 /*: any*/),
                                (v41 /*: any*/),
                                (v27 /*: any*/),
                                (v26 /*: any*/),
                                (v4 /*: any*/),
                                (v29 /*: any*/),
                                (v30 /*: any*/),
                                (v31 /*: any*/),
                                (v42 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "images",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Images",
                                    "plural": false,
                                    "selections": [
                                        (v33 /*: any*/),
                                        (v34 /*: any*/),
                                        (v35 /*: any*/),
                                        (v32 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartAddMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartAdd",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartAddPayload",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                (v2 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodes",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCode",
                                    "plural": true,
                                    "selections": [
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v23 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entries",
                                    "storageKey": "entries(first:1000)",
                                    "args": (v24 /*: any*/),
                                    "concreteType": "CartEntryV3Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV3Edge",
                                            "plural": true,
                                            "selections": [
                                                (v25 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Product",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v27 /*: any*/),
                                                                (v28 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v36 /*: any*/),
                                                                (v38 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entriesV2",
                                    "storageKey": "entriesV2(first:1000)",
                                    "args": (v24 /*: any*/),
                                    "concreteType": "CartEntryV2Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV2Edge",
                                            "plural": true,
                                            "selections": [
                                                (v25 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV2",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductV2",
                                                            "plural": false,
                                                            "selections": [
                                                                (v27 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v39 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v36 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodeDiscountedItems",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCodeDiscountItem",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "nonDiscountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v43 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "discountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v43 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartAddMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartAdd",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartAddPayload",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cart",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Cart",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                (v2 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodes",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCode",
                                    "plural": true,
                                    "selections": [
                                        (v20 /*: any*/),
                                        (v21 /*: any*/),
                                        (v23 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entries",
                                    "storageKey": "entries(first:1000)",
                                    "args": (v24 /*: any*/),
                                    "concreteType": "CartEntryV3Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV3Edge",
                                            "plural": true,
                                            "selections": [
                                                (v25 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Product",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v27 /*: any*/),
                                                                (v28 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v44 /*: any*/),
                                                                (v38 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "entriesV2",
                                    "storageKey": "entriesV2(first:1000)",
                                    "args": (v24 /*: any*/),
                                    "concreteType": "CartEntryV2Connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CartEntryV2Edge",
                                            "plural": true,
                                            "selections": [
                                                (v25 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV2",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "product",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductV2",
                                                            "plural": false,
                                                            "selections": [
                                                                (v27 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v4 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v39 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v44 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promoCodeDiscountedItems",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromoCodeDiscountItem",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "nonDiscountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v45 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "discountedSkus",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCodeItemDiscountConnection",
                                            "plural": false,
                                            "selections": (v45 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartAddMutation",
            "id": null,
            "text": "mutation CartAddMutation(\n  $input: CartAddInput!\n) {\n  cartAdd(input: $input) {\n    cartEntryEdge {\n      node {\n        id\n        quantity\n        product {\n          id\n          productId\n        }\n      }\n    }\n    cart {\n      id\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      c4cMode\n      enrollingAsPc\n      totalSavings\n      promoCodeSavings\n      pcPotentialSavings\n      viaQualifiedCartTotal\n      totalNumberOfItems\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithPromoCodes\n      eventId\n      event {\n        id\n        trinityPartyType\n      }\n      promoCodes {\n        code\n        promoDescription\n        thresholds {\n          discountAmount\n          discountAmountEach\n        }\n        id\n      }\n      entries(first: 1000) {\n        edges {\n          cursor\n          node {\n            id\n            quantity\n            product {\n              id\n              price\n              name\n              priceSale\n              productId\n              wineBottleQuantity\n              isWinePack\n              productPermissions {\n                oneCommerce {\n                  preferredCustomer {\n                    add\n                  }\n                }\n              }\n              images {\n                squareFront\n                productCatalog\n                productFront\n                productBack\n                id\n              }\n              promoCodeDiscount {\n                case4Cause {\n                  case6SKU\n                  case12SKU\n                  donationEligible\n                  case12PriceUSD\n                  case6PriceUSD\n                }\n              }\n            }\n          }\n        }\n      }\n      entriesV2(first: 1000) {\n        edges {\n          cursor\n          node {\n            id\n            quantity\n            product {\n              name\n              id\n              productId\n              price\n              finalPrice\n              productPermissions {\n                oneCommerce {\n                  preferredCustomer {\n                    add\n                  }\n                }\n              }\n              images {\n                squareFront\n                productCatalog\n                productFront\n                productBack\n                id\n              }\n            }\n          }\n        }\n      }\n      promoCodeDiscountedItems {\n        id\n        nonDiscountedSkus {\n          edges {\n            cursor\n            node {\n              id\n              sku\n              discountAmount\n              productId\n              quantity\n              product {\n                id\n                productId\n                productURLslug\n                name\n                price\n                priceSale\n                wineBottleQuantity\n                isWinePack\n                productPermissions {\n                  oneCommerce {\n                    preferredCustomer {\n                      add\n                    }\n                  }\n                }\n                promoCodeDiscount {\n                  case4Cause {\n                    case6PriceUSD\n                  }\n                }\n                images {\n                  productCatalog\n                  productFront\n                  productBack\n                  squareFront\n                  id\n                }\n              }\n            }\n          }\n        }\n        discountedSkus {\n          edges {\n            cursor\n            node {\n              id\n              sku\n              discountAmount\n              productId\n              quantity\n              product {\n                id\n                productId\n                productURLslug\n                name\n                price\n                priceSale\n                wineBottleQuantity\n                isWinePack\n                productPermissions {\n                  oneCommerce {\n                    preferredCustomer {\n                      add\n                    }\n                  }\n                }\n                promoCodeDiscount {\n                  case4Cause {\n                    case6PriceUSD\n                  }\n                }\n                images {\n                  productCatalog\n                  productFront\n                  productBack\n                  squareFront\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'ddf7f368cf3a10efe924aa0da5f5bfbc';
export default node;
